import TraitsListMobile from './TraitsListMobile'

export default TraitsListMobile
